import { Dispatch, createContext } from 'react';
import { ReducerAction } from './reducer';
import { FilterParams, initialState } from '../domain/filter';

export const FilterContext = createContext<{
  filterState: FilterParams;
  dispatch: Dispatch<ReducerAction>;
}>({ filterState: initialState, dispatch: () => undefined });
